import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DomainConfigurations } from '../../viewmodels/configuration/domain-configurations';
import { BackendService } from '../backend.service';

@Injectable({
  providedIn: 'root',
})
export class DomainConfigurationService {
  constructor(private backendService: BackendService) {}

  public getConfiguration(): Observable<DomainConfigurations> {
    return this.backendService.get(DomainConfigurations);
  }
}
